import { useState, type FormEvent } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { toast } from 'sonner'
import { api, apiErrorMessage } from '../lib/api'
import { useAuthStore } from '../stores/auth'
import type { UserDto } from '@emag/shared'

export function LoginPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      const res = await api.post<{ accessToken: string; user: UserDto }>('/auth/login', {
        email,
        password,
      })
      useAuthStore.getState().setSession(res.data.accessToken, res.data.user)
      navigate('/', { replace: true })
    } catch (err) {
      toast.error(apiErrorMessage(err, 'Autentificare eșuată'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-b4l-bg px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-xl border border-b4l-border bg-white p-6 shadow-sm"
      >
        <h1 className="mb-1 text-center text-lg font-semibold text-b4l-green-dark">eMAG Platform</h1>
        <p className="mb-5 text-center text-[12px] text-b4l-text-dim">Autentificare</p>

        <label className="mb-1 block text-[12px] text-b4l-text-muted">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          className="mb-3 w-full rounded-md border border-b4l-border px-3 py-2 text-[13px] outline-none focus:border-b4l-green"
        />

        <label className="mb-1 block text-[12px] text-b4l-text-muted">Parolă</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="mb-5 w-full rounded-md border border-b4l-border px-3 py-2 text-[13px] outline-none focus:border-b4l-green"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-md bg-b4l-green py-2 text-[13px] font-medium text-white transition-colors hover:bg-b4l-green-dark disabled:opacity-60"
        >
          {loading ? 'Se conectează…' : 'Conectare'}
        </button>

        <Link
          to="/resetare-parola"
          className="mt-4 block text-center text-[12px] text-b4l-green hover:underline"
        >
          Am uitat parola
        </Link>
      </form>
    </div>
  )
}
